import { random } from '../random';

export const SKIN_TONES = ['#f6d7c3', '#eebd98', '#d69e74', '#b07850', '#8a5636', '#5c3a24'];
export const HAIR_COLORS = ['#1f1a17', '#4a2f1e', '#8b5a2b', '#d9b26a', '#c4512c', '#6b6b6b'];
const GEAR_COLORS = ['#d8342c', '#2f6fd6', '#2e9e57', '#f2b31c', '#7d4bc4', '#f07a2a'];
const BACKGROUNDS = ['#2b5f8a', '#3c7d4f', '#8a3c3c', '#6a4a8a', '#3a6f7a', '#8a6a2b'];

/** Hair styles a guy or a girl can have (TrainerAvatar draws each). */
export const GUY_HAIR = ['short', 'spiky', 'side'];
export const GIRL_HAIR = ['long', 'ponytail', 'bob'];

const pick = (next, list) => list[Math.floor(next() * list.length)];

/**
 * What a computer opponent looks like, from a seed: a guy or a girl, skin, hair, and a cap (guys) or a beanie (girls)
 * or none. The same seed is always the same trainer.
 *
 * @returns {{ girl: boolean, skin: string, hair: string, hairStyle: string, hat: ?string, hatColor: string,
 *   shirt: string, background: string }}
 */
export function trainerLook(seed) {
  const next = random(seed);
  const girl = next() < 0.5;
  return {
    girl,
    skin: pick(next, SKIN_TONES),
    hair: pick(next, HAIR_COLORS),
    hairStyle: pick(next, girl ? GIRL_HAIR : GUY_HAIR),
    hat: next() < 0.55 ? (girl ? 'beanie' : 'cap') : null,
    hatColor: pick(next, GEAR_COLORS),
    shirt: pick(next, GEAR_COLORS),
    background: pick(next, BACKGROUNDS),
  };
}
